import {MAP, DELETE} from 'constants/midi-map-modes.js';

import {setParameterSliderDown} from "actions/index.js";
import {setParameterMidiMapping} from 'actions/index.js';
import {setActionMidiMapping} from 'actions/index.js';
import {deleteMidiMappings} from 'actions/index.js';

let counter = 0;

export default superclass => class extends superclass  {
    get midiMappings() {
        return this.state.midi.mappings;
    }

    get midiMapMode() {
        return this.state.midi.midiMapMode;
    }

    onMappedParameterChange(e) {
        let parameters = this.midiMappings[e.controller.number].map(
            e => this.sequencerEngine.idToParameter[e])
            .filter(x => x && x.object);

        let value = e.value / 127.0;
        if (parameters.length > 0) {
            let id = ++counter;
            let parameter = parameters[0];
            this.sequencerEngine.dispatch(
                setParameterSliderDown(parameter));
            setTimeout(() => {
                if (counter === id) {
                    this.sequencerEngine.dispatch(
                        setParameterSliderDown(undefined));
                }
            }, 150);
        }
        parameters.forEach(p => p.normalizedSet(value));
    }

    isParameterMapped(e) {
        let number = e.controller.number;
        return this.midiMappings[number] &&
            (this.parameterSelected === undefined ||
             this.midiMappings[number].indexOf(this.parameterSelected) > -1);
    }

    onControllerAux(e) {
        let number = e.controller.number;
        if (this.midiMapMode === DELETE) {
            this.store.dispatch(deleteMidiMappings(number));
        } else if (this.isParameterMapped(e)) {
            this.onMappedParameterChange(e);
       } else if
            (this.actionMappings[number] &&
             (this.actionSelected === undefined ||
              this.actionMappings[number].indexOf(this.actionSelected) > -1)) {
                let actions = this.actionMappings[number];
                actions.forEach(action => action.execute(e.value));
            } else if (this.midiMapMode === MAP && this.actionSelected) {
                this.store.dispatch(setActionMidiMapping(this.actionSelected, number));
            } else if (this.midiMapMode === MAP && this.parameterSelected) {
                this.store.dispatch(setParameterMidiMapping(this.parameterSelected, number));
            }
    }

    get midiMapMode() {
        return this.state.midi.midiMapMode;
    }

    get parameterSelected() {
        return this.state.midi.parameterSelected;
    }

    get midiMappings() {
        return this.state.midi.mappings;
    }

    get actionSelected() {
        return this.state.midi.actionSelected;
    }

    get actionMappings() {
        return this.state.midi.actionMappings;
    }
}
